import { http } from 'http';

export default {
  uploadDocument: ({ container, folder, docType, file }) =>
    http.post(`/flex/docs/${container}/${folder}/${docType}`, file, {
      headers: { 'content-type': 'multipart/form-data' }
    })
};
